import React from "react";
import useCountUp from "../hooks/useCountUp";

function HomeAguadaSection({ enAguada, enAguadaGanados, enAguadaPerdidos, getPercentage, isLoading }) {
    const countEnAguada = useCountUp(enAguada, 2200, isLoading);
    const countEnAguadaGanados = useCountUp(enAguadaGanados, 2200, isLoading);
    const countEnAguadaPerdidos = useCountUp(enAguadaPerdidos, 2200, isLoading);

    return (
        <div className="relative mt-10 overflow-hidden rounded-3xl border border-white/20 bg-white/5 p-6 shadow-2xl backdrop-blur-xl sm:mt-16 sm:p-10">
            <span className="pointer-events-none absolute left-0 top-0 h-0.5 w-1/2 bg-green-400"></span>
            <span className="pointer-events-none absolute bottom-0 right-0 h-0.5 w-1/3 bg-red-500"></span>
            <h3 className="text-white font-bold uppercase tracking-widest text-lg sm:text-xl mb-6 sm:mb-8 text-center drop-shadow-sm">En Aguada...</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-white/10 text-white">
                <div className="py-6 md:py-0">
                    <div className="text-4xl cellphone:text-5xl md:text-6xl text-white font-bold tracking-tighter">{countEnAguada}</div>
                    <div className="text-slate-400 uppercase tracking-widest text-xs font-black mt-3">Partidos Jugados</div>
                </div>
                <div className="py-6 md:py-0">
                    <div className="flex items-center justify-center gap-2">
                        <span className="text-4xl cellphone:text-5xl md:text-6xl text-white font-bold tracking-tighter">{countEnAguadaGanados}</span>
                        <span className="text-green-400 text-sm font-black px-2 py-1 rounded">({getPercentage(countEnAguadaGanados, countEnAguada)}%)</span>
                    </div>
                    <div className="text-slate-400 uppercase tracking-widest text-xs font-black mt-3">Partidos Ganados</div>
                </div>
                <div className="py-6 md:py-0">
                    <div className="flex items-center justify-center gap-2">
                        <span className="text-4xl cellphone:text-5xl md:text-6xl text-white font-bold tracking-tighter">{countEnAguadaPerdidos}</span>
                        <span className="text-red-400 text-sm font-black px-2 py-1 rounded">({getPercentage(countEnAguadaPerdidos, countEnAguada)}%)</span>
                    </div>
                    <div className="text-slate-400 uppercase tracking-widest text-xs font-black mt-3">Partidos Perdidos</div>
                </div>
            </div>
        </div>
    );
}

export default HomeAguadaSection;
